import Call from "../../../hocs/call";
import EnhancedTree from "../../../components/enhanced-tree";
import {getUrnFromArtefact, SDMX_JSON_DATAFLOW_URN_NAMESPACE} from "../../../utils/sdmxJson";
import {getNodes, UNCATEGORIZED_CATEGORY_CODE} from "../../../utils/tree";
import {getLocalizedStr} from "../../../middlewares/i18n/utils";
import React from "react";
import {
  categoriseCategorySchemesAndDataflowsDataflow,
  changeCategorySchemesAndDataflowsLanguage,
  deleteCategorySchemesAndDataflowsDataflowCategorisation,
  readCategorySchemesAndDataflowsTree
} from "./actions";
import {Modal} from "antd";
import "./style.css"
import {categorisationsSorterFactory} from "./utils";
import {connect} from "react-redux";
import {compose} from "redux";
import {translate} from "react-i18next";

const mapStateToProps = state => ({
  permissions: state.app.user.permissions,
  tree: state.scenes.metaManager.categorySchemesAndDataflows.tree,
  categorisations: state.scenes.metaManager.categorySchemesAndDataflows.categorisations,
  nodeId: state.app.endpointId,
  nodes: state.config.nodes,
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages,
});

const mapDispatchToProps = dispatch => ({
  fetchTree: lang => dispatch(readCategorySchemesAndDataflowsTree(lang)),
  onDataflowCategorise: (dataflow, categoryUrn, categorisations, from, to, fromSisterDfOrderedCategorisations, toSisterDfOrderedCategorisations, lang, orderAnnotationType, agencyPermissions, t) =>
    dispatch(categoriseCategorySchemesAndDataflowsDataflow(dataflow, categoryUrn, categorisations, from, to, fromSisterDfOrderedCategorisations, toSisterDfOrderedCategorisations, lang, orderAnnotationType, agencyPermissions, t)),
  onDeleteDataflowCategorisation: (dataflow, categorisations) =>
    dispatch(deleteCategorySchemesAndDataflowsDataflowCategorisation(dataflow, categorisations)),
  onLanguageChange: () => dispatch(changeCategorySchemesAndDataflowsLanguage())
});

const onDrop = (ev, onDataflowCategorise, categorisations, t, lang, orderAnnotationType, agencyPermissions) => {

  const draggedInto = ev.node.props["data-node"];

  if (ev.dragNode.props["data-node"].type === "dataflow") {

    const dataflow = ev.dragNode.props["data-node"];

    const pos = ev.node.props.pos.split('-');
    const dropPos = ev.dropPosition - Number(pos[pos.length - 1]);

    let fromSisterDfOrderedCategorisations =
      categorisations
        .filter(({source, target}) =>
          source.includes(SDMX_JSON_DATAFLOW_URN_NAMESPACE) &&
          target === dataflow.categoryUrn
        )
        .sort(categorisationsSorterFactory(orderAnnotationType, lang));
    const toSisterDfOrderedCategorisations =
      categorisations
        .filter(({source, target}) =>
          source.includes(SDMX_JSON_DATAFLOW_URN_NAMESPACE) &&
          (target === (ev.dropToGap ? draggedInto.categoryUrn : draggedInto.urn))
        )
        .sort(categorisationsSorterFactory(orderAnnotationType, lang));

    let from = fromSisterDfOrderedCategorisations.map(({source}) => source).indexOf(dataflow.urn);
    let to = toSisterDfOrderedCategorisations.map(({source}) => source).indexOf(draggedInto.urn);

    if (ev.dropToGap) {

      if (draggedInto.categoryUrn === dataflow.categoryUrn) {

        // same category

        fromSisterDfOrderedCategorisations = [];

        to = from < to
          ? dropPos < 0 // moving forward into the array
            ? to - 1 // dropPos = -1 => drag on top node gap
            : to // dropPos = 1 => drag on bottom node gap
          : dropPos < 0 // moving backwards into the array
            ? to // dropPos = -1 => drag on top node gap
            : to + 1; // dropPos = 1 => drag on bottom node gap
        if (to === -1) {
          to = 0
        }
        if (to === toSisterDfOrderedCategorisations.length + 1) {
          to = toSisterDfOrderedCategorisations.length
        }

      } else {

        // other category

        if (toSisterDfOrderedCategorisations.find(({source}) => source === getUrnFromArtefact(dataflow))) {
          Modal.error({title: t("scenes.metaManager.categorySchemesDataflowsTree.errors.duplicateCategorisation.title")});
          return;
        }

        to = dropPos < 0 // moving backwards into the array
          ? to // dropPos = -1 => drag on top node gap
          : to + 1; // dropPos = 1 => drag on bottom node gap;
        if (to === -1) {
          to = 0
        }
        if (to === toSisterDfOrderedCategorisations.length + 1) {
          to = toSisterDfOrderedCategorisations.length
        }
      }

      draggedInto.categoryUrn
        ? onDataflowCategorise(dataflow, draggedInto.categoryUrn, categorisations, from, to, fromSisterDfOrderedCategorisations, toSisterDfOrderedCategorisations, lang, orderAnnotationType, agencyPermissions, t)
        : Modal.error({title: t("scenes.metaManager.categorySchemesDataflowsTree.errors.notValidCategory.title")});

    } else if (draggedInto.urn && draggedInto.type === "category") {

      if (toSisterDfOrderedCategorisations.find(({source}) => source === getUrnFromArtefact(dataflow))) {
        Modal.error({title: t("scenes.metaManager.categorySchemesDataflowsTree.errors.duplicateCategorisation.title")});
      } else {
        onDataflowCategorise(dataflow, draggedInto.urn, categorisations, from, 0, fromSisterDfOrderedCategorisations, toSisterDfOrderedCategorisations, lang, orderAnnotationType, agencyPermissions, t)
      }

    } else {
      Modal.error({title: t("scenes.metaManager.categorySchemesDataflowsTree.errors.notValidCategory.title")});
    }
  } else {
    Modal.error({title: t("scenes.metaManager.categorySchemesDataflowsTree.errors.canDragOnlyDataflow.title")});
  }
};

const CategorySchemesAndDataflows = ({
                                       t,
                                       permissions,
                                       tree,
                                       categorisations,
                                       nodes,
                                       nodeId,
                                       appLanguage,
                                       dataLanguages,
                                       fetchTree,
                                       onDataflowCategorise,
                                       onDeleteDataflowCategorisation,
                                       onLanguageChange
                                     }) => {

  const orderAnnotationType = nodes.find(node => node.general.id === nodeId).annotations.categorisationsOrder;

  return (
    <Call
      cb={() => fetchTree(appLanguage)}
      disabled={!(nodes && nodes.length > 0 && tree === null)}
    >
      <Call
        cb={onLanguageChange}
        cbParam={appLanguage}
        checkCbParamChangeOnly
        disableFirst
      >
        <div className="category-schemes-and-dataflows__categorisation__tree">
          <EnhancedTree
            tree={tree}
            getNodeKey={node => node.id === UNCATEGORIZED_CATEGORY_CODE ? UNCATEGORIZED_CATEGORY_CODE : getUrnFromArtefact(node)}
            childrenKey="categories"
            idKey="id"
            nameKey="name"
            catIdKey="id"
            catNameKey="name"
            defaultCollapsed
            getFilter={
              searchText =>
                ({id, name}) => {
                  const search = searchText.toLowerCase();
                  return (id && id.toLowerCase()
                      .indexOf(search) >= 0) ||
                    getLocalizedStr(name, appLanguage, dataLanguages)
                      .toLowerCase()
                      .indexOf(search) >= 0;
                }
            }
            hiddenIdKeys={[UNCATEGORIZED_CATEGORY_CODE]}
            icon="file-text"
            getIconColor={() => "#37a0f4"}
            treeActions={[
              {
                title: t('scenes.metaManager.categorySchemesDataflowsTree.tree.refreshButton.title'),
                icon: 'sync',
                onClick: () => fetchTree(appLanguage)
              }
            ]}
            draggable
            unselectableKeys={[
              ...getNodes(tree, 'categories', () => true)
                .map(node =>
                  node.id === UNCATEGORIZED_CATEGORY_CODE ? UNCATEGORIZED_CATEGORY_CODE : getUrnFromArtefact(node)
                )
            ]}
            onDrop={ev => onDrop(ev, onDataflowCategorise, categorisations, t, appLanguage, orderAnnotationType, permissions ? permissions.agencies : [])}
            rightClickActions={[
              node => (node.type === "dataflow" && node.categoryUrn)
                ? ({
                  icon: 'disconnect',
                  title: t('scenes.metaManager.categorySchemesDataflowsTree.tree.actions.deleteCategorisation.title'),
                  onClick: () => onDeleteDataflowCategorisation(node, categorisations)
                })
                : null
            ]}
          />
        </div>
      </Call>
    </Call>
  )
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(CategorySchemesAndDataflows);




// WEBPACK FOOTER //
// ./src/scenes/meta-manager/category-schemes-and-dataflows/index.jsx